Ext.define('SA.model.RadiusLocation', {
    extend: 'SA.model.CustomLocation',

    constructor({radiusSizeInMeters, centerLocation}) {
        this.callParent(arguments);

        this.radiusSizeInMeters = radiusSizeInMeters;
        this.centerLocation = centerLocation;
    },

    getCenterLocationId() {
        return this.centerLocation.getId();
    },

    getGeoUnitId() {
        return this.centerLocation.getGeoUnitId();
    },

    getRadiusSizeInMeters() {
        return this.radiusSizeInMeters;
    },

    hasCensusReleaseYear(censusReleaseYear) {
        return this.centerLocation.hasCensusReleaseYear(censusReleaseYear);
    }
});